import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import {
    Box,
    Button,
    CircularProgress,
    Divider,
    Grid,
    IconButton,
    InputLabel,
    makeStyles,
    TextareaAutosize,
    FormHelperText,
    Typography,
} from "@material-ui/core";
import CustomInput from "../../Components/CustomInput";
const useStyles = makeStyles((theme) => ({
    formWrapper: {
        background: "#fff",
        width: "400px",
        padding: theme.spacing(3),

    },
    title: {
        textTransform: "none",
        marginTop: 1
    },
    actionButtons: {
        paddingTop: "14px",
        textAlign: "right",
        textTransform: "none"
        // "& button": {
        //   marginRight: "20px",
        // },
    },
    textarea: {
        fontSize: 16,
        lineHeight: 1.4,
        paddingLeft: '13px',
        fontFamily: 'inherit',
        paddingTop: '11px',
        color: theme.palette.grey[500],
        "&:placeholder": {
            color: "#808080",
            opacity: 1,
            marginLeft: "12px"
        }
    },
    labelText: {
        fontSize: "16px",
        marginTop: '-13px',
        marginLeft: '-13px'
    }
}));
const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),

    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],

    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

function Requestforassistance(props) {
    const classes = useStyles();
    const {
        handleClose,
        title,
        submitHandler,
        errors,
        setErrors,
        isRequesting,
    } = props;
    // var data = { number: "", query: "" };
    // const [userData, setUserData] = useState([]);
    // const [pageData, setPageData] = useState(data);

    // useEffect(() => {}, []);
    // const sendRequest = () => {
    //   console.log(userData);
    // };
    // const setInputState = (inputStateValue, inputId) => {
    //   setUserData({ ...userData, [inputId]: inputStateValue });
    // };

    const formSubmitHandler = (e) => {
        e.preventDefault();
        typeof submitHandler === "function" && submitHandler(e);
    };

    return (
        <div>
            <Dialog
                maxWidth={"sm"}
                style={{ height: "70%", margin: "50px auto" }}
                open={true}
                onClose={handleClose}
                aria-labelledby="base-station-manage"
            >
                <Box width="100%" display="flex" justifyContent="space-between">
                    <DialogTitle id="customized-dialog-title">{title}</DialogTitle>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Divider />
                <DialogContent style={{ margin: "0px auto" }}>
                    <form
                        className={classes.formWrapper}
                        onSubmit={(e) => formSubmitHandler(e)}
                    > <Grid
                        container
                        direction="row"
                        alignItems="center"
                        style={{ marginBottom: 20 }}
                    >
                            <Grid item xs={4}>
                                <InputLabel className={classes.labelText}>Requestor name</InputLabel>
                            </Grid>
                            <Grid item xs={8}>
                                <CustomInput
                                    name="name"
                                    error={errors.name}
                                    mulitline={3}
                                    id="name"
                                    variant="outlined"
                                    placeholder="Enter your name"
                                    setError={() =>
                                        setErrors((prevState) => ({ ...prevState, query: false }))
                                    }
                                    // parentcall={setInputState}
                                    // value={userData.telephone}
                                    autoFocus={errors.name}
                                    helperText={errors.name && "Enter your name"}
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            alignItems="center"
                            style={{ marginBottom: 20 }}
                        >
                            <Grid item xs={4}>
                                <InputLabel className={classes.labelText}>
                                    Contact number
                                </InputLabel>
                            </Grid>
                            <Grid item xs={8}>
                                <CustomInput
                                    name="contact_number"
                                    id="phoneNumber"
                                    variant="outlined"
                                    placeholder="Enter your preferred contact number"
                                    error={errors.contact_number}
                                    setError={() =>
                                        setErrors((prevState) => ({
                                            ...prevState,
                                            contact_number: false,
                                        }))
                                    }

                                    helperText={
                                        errors.contact_number && "Enter your preferred contact number"

                                    }
                                    autoFocus={errors.contact_number}
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            alignItems="center"
                            style={{ marginBottom: 20 }}
                        >
                            <Grid item xs={4}>
                                <InputLabel className={classes.labelText}>Email</InputLabel>
                            </Grid>
                            <Grid item xs={8}>
                                <CustomInput
                                    name="email"
                                    error={errors.email}
                                    mulitline={3}
                                    id="email"
                                    variant="outlined"
                                    placeholder="Enter your email address
 "
                                    setError={() =>
                                        setErrors((prevState) => ({ ...prevState, email: false }))
                                    }
                                    // parentcall={setInputState}
                                    // value={userData.telephone}
                                    autoFocus={errors.email}
                                    helperText={errors.email && "Enter your email address"}
                                />
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            alignItems="center"
                            style={{ marginBottom: 20 }}
                        >
                            <Grid item xs={4}>

                                <InputLabel className={classes.labelText}>{title === "Request for assistance" ? "Query/Comments" : "Request"}</InputLabel>
                            </Grid>
                            <Grid item xs={8}>
                                <TextareaAutosize
                                    aria-label="minimum height"
                                    name='request'
                                    id="request"
                                    error={errors.request}
                                    minRows={3}
                                    placeholder={title === "Request for assistance" ? "Enter your comments" : "Enter your request"}
                                    setError={() =>
                                        setErrors((prevState) => ({ ...prevState, request: false }))
                                    }
                                    autoFocus={errors.request}
                                    // helperText={errors.request && "Enter your comments"}
                                    style={{ width: "263px", borderColor: errors.request ? "red" : "" }}
                                    className={classes.textarea} />
                                {errors.request ?
                                    <FormHelperText style={{ color: 'red' }}>{title === "Request for assistance" ? "Enter your comments" : "Enter details of your request"}</FormHelperText> : <></>}

                            </Grid>
                        </Grid>




                        {/* <CustomInput
                                    name="request"
                                    error={errors.request}
                                    mulitline={3}
                                    id="request"
                                    variant="outlined"
                                    placeholder="Enter your request"
                                    setError={() =>
                                        setErrors((prevState) => ({ ...prevState, request: false }))
                                    }
                                    // parentcall={setInputState}
                                    // value={userData.telephone}
                                    autoFocus={errors.request}
                                    helperText={errors.request && "Please enter Query"}
                                /> */}

                        <div className={classes.actionButtons}>
                            <Button
                                disableElevation
                                type="button"
                                style={{ marginRight: 10, textTransform: "none" }}
                                variant={"contained"}
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                disableElevation
                                type="submit"
                                variant={"contained"}
                                color="secondary"
                                disabled={isRequesting}
                                style={{ textTransform: "none" }}
                            // onClick={sendRequest}
                            >
                                {isRequesting ? <CircularProgress size={20} /> : "Submit"}
                            </Button>
                        </div>
                    </form>
                </DialogContent>
            </Dialog>
            )
        </div>
    );
}

export default Requestforassistance